import React, { useState } from 'react';
import { TextField, Button, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Checkbox, Typography, Box, CircularProgress } from '@mui/material';
import getEmail from '../../functions/getEmail';
import { EmailService } from '../../services/email';
import { toast } from 'react-toastify';
import PhoneNumberInput from '../../components/inputPhoneNumber';

const FormCotacao: React.FC = () => {

  const [disabled, setDisabled] = useState<boolean>(false);

  const instance = new EmailService();

  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    cidade: '',
    plano: '',
    aceito: false,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };
 // telefone input 
  const [phone, setPhone] = useState({ masked: "", unmasked: "" });

  const handlePhoneChange = (maskedValue: string, unmaskedValue: string, name: string) => {
    setPhone({ masked: maskedValue, unmasked: unmaskedValue });

    setFormData({ ...formData, [name]: maskedValue });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.aceito) {
      alert('Você precisa aceitar as políticas de privacidade');
      return;
    }

    setDisabled(true);

    const payload = {
      nome: formData.nome,
      telefone: formData.telefone,
      email: formData.email,
      cidade: formData.cidade,
      plano: formData.plano,
      aceito: formData.aceito,
    }
    sendMensagem(payload);
  
  };

  const sendMensagem = (payload: any) => {

    instance
    .send_email_cotacao(payload)
    .then(res => {      
      clear();
    })
    .catch(error => {
      console.log('error', error);
      setDisabled(false);
    });

  }

  const clear = () => {
    setFormData(
      {
        nome: '',
        telefone: '',
        email: '',
        cidade: '',
        plano: 'Para mim',
        aceito: false,
      }
    )
    toast.success('Formulário enviado com sucesso!');
    setDisabled(false);
  }

  return (
    <Box sx={{ maxWidth: 700,  mx: 'auto', mt: 5, mb: 5, backgroundColor: "#f9f9f9", borderRadius: "1em", padding: "1em" }}>
      <Typography variant="h5" component="h2" gutterBottom textAlign={"center"}>
        Preencha as informações abaixo
      </Typography>
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          required
          size='small'
          label="Nome"
          name="nome"
          value={formData.nome}
          onChange={handleChange}
          fullWidth
          margin="normal"
        />
        <Box sx={{ display: "flex", gap: "2em"}}>
            <TextField
              required
              size='small'
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            
            <TextField
              required
              size='small'
              label="Cidade"
              name="cidade"
              value={formData.cidade}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
        </Box>
        <Box sx={{ display: "flex", gap: "2em", alignItems: "center"}}>
          <PhoneNumberInput
            value={formData.telefone}
            onChange={handlePhoneChange}
            name="telefone"
            label='Telefone'
          />
          <FormControl   color='warning' component="fieldset" margin="normal" fullWidth>
              <FormLabel component="legend" color='warning'>Para quem é o Plano?</FormLabel>
              <RadioGroup name="plano" row value={formData.plano} onChange={handleChange}>
                  <FormControlLabel value="Para mim" control={<Radio color='warning' />} label="Para mim" />
                  <FormControlLabel value="Para minha família" control={<Radio color='warning' />} label="Para minha família" />
                  <FormControlLabel value="Para minha empresa" control={<Radio color='warning' />} label="Para minha empresa" />
              </RadioGroup>
          </FormControl>
        </Box>
        <FormControlLabel
            sx={{ mt: 2}}
            control={
                <Checkbox
                  color='warning'
                  name="aceito"
                  checked={formData.aceito}
                  onChange={handleChange}
                />
            }
            label={
                <>
                    Aceito as <a className='a' href="/politicas-de-privacidade-e-lgpd">políticas de privacidade</a> e LGPD e concordo em 
                    compartilhar minhas informações e receber um contato de um corretor parceiro para minha cotação gratuita.
                </>
            }
            />
        <Button 
          size='small'
          type="submit" 
          variant="contained" 
          color="warning" 
          fullWidth 
          disabled={disabled}
        >
           {disabled ? <CircularProgress size={24} color="inherit" /> : '✓ Enviar E-mail'} 
        </Button>
      </Box>
    </Box>
  );
};

export default FormCotacao;
